export const dedupe = <T>(a: ReadonlyArray<T>) => a.filter((elem, pos, arr) => arr.indexOf(elem) === pos)

export const dedupeByProperty = <T>(arr: ReadonlyArray<T>, objKey: keyof T) =>
  arr.reduce<ReadonlyArray<T>>((acc, curr) => (acc.some(a => a[objKey] === curr[objKey]) ? acc : [...acc, curr]), [])
